<script setup>

import { useStore } from "vuex";
import { onBeforeMount } from 'vue';
import bootstrap from "bootstrap/dist/js/bootstrap";
import axios from "axios";
import validSession from "../assets/js/valid-session";
import { toast } from 'vue3-toastify';
import loadGif from "@/assets/img/loading.gif"
import ObjetivesRow from "../components/ObjetivesRow.vue";
import { computed } from "vue";
import FlatPickr from "vue-flatpickr-component";
import { Portuguese } from "flatpickr/dist/l10n/pt.js";
import "flatpickr/dist/flatpickr.css";

const colors = [
  "#FF6B6B", "#FF5252", "#E53935", "#EF5350",
  "#F06292", "#EC407A", "#FF80AB", "#F48FB1",
  "#BA68C8", "#AB47BC", "#9C27B0", "#CE93D8",
  "#7986CB", "#5C6BC0", "#3F51B5", "#64B5F6",
  "#42A5F5", "#1E88E5", "#2196F3",
  "#4DD0E1", "#26C6DA", "#00ACC1", "#4DB6AC",
  "#26A69A", "#009688",
  "#81C784", "#66BB6A", "#4CAF50", "#43A047",
  "#AED581", "#9CCC65",
  "#DCE775", "#FFF176", "#FFD54F", "#FFEB3B",
  "#FFB74D", "#FFA726", "#FB8C00", "#FF9800",
  "#FFAB91", "#FFCCBC", "#FFE0B2", "#FFF9C4",
  "#DCEDC8", "#C8E6C9",
  "#B0BEC5", "#90A4AE", "#78909C", "#A1887F",
  "#00C853", "#00BFA5", "#2962FF", "#6200EA",
  "#D500F9", "#C51162", "#FF1744", "#FF9100"
]

const value_objetive = {
    value: 0
};

const money = {
          decimal: ',',
          thousands: '.',
          prefix: 'R$ ',
          suffix: '',
          precision: 2,
          masked: false /* doesn't work with directive */
        }

let icons = [];

let icons_new = [
  {
    "name": "Utensils",
    "icon": "utensils",
    "class": "fa-utensils",
    "group": "Alimentação"
  },
  {
    "name": "Coffee",
    "icon": "coffee",
    "class": "fa-coffee",
    "group": "Alimentação"
  },
  {
    "name": "Hamburger",
    "icon": "hamburger",
    "class": "fa-hamburger",
    "group": "Alimentação"
  },
  {
    "name": "Pizza Slice",
    "icon": "pizza-slice",
    "class": "fa-pizza-slice",
    "group": "Alimentação"
  },
  {
    "name": "Apple Alt",
    "icon": "apple-alt",
    "class": "fa-apple-alt",
    "group": "Alimentação"
  },
  {
    "name": "Carrot",
    "icon": "carrot",
    "class": "fa-carrot",
    "group": "Alimentação"
  },
  {
    "name": "Ice Cream",
    "icon": "ice-cream",
    "class": "fa-ice-cream",
    "group": "Alimentação"
  },
  {
    "name": "Lemon",
    "icon": "lemon",
    "class": "fa-lemon",
    "group": "Alimentação"
  },
  {
    "name": "Fish",
    "icon": "fish",
    "class": "fa-fish",
    "group": "Alimentação"
  },
  {
    "name": "Bread Slice",
    "icon": "bread-slice",
    "class": "fa-bread-slice",
    "group": "Alimentação"
  },
  {
    "name": "Egg",
    "icon": "egg",
    "class": "fa-egg",
    "group": "Alimentação"
  },
  {
    "name": "Cheese",
    "icon": "cheese",
    "class": "fa-cheese",
    "group": "Alimentação"
  },
  {
    "name": "Hotdog",
    "icon": "hotdog",
    "class": "fa-hotdog",
    "group": "Alimentação"
  },
  {
    "name": "Drumstick Bite",
    "icon": "drumstick-bite",
    "class": "fa-drumstick-bite",
    "group": "Alimentação"
  },
  {
    "name": "Wine Bottle",
    "icon": "wine-bottle",
    "class": "fa-wine-bottle",
    "group": "Alimentação"
  },
  {
    "name": "Wine Glass",
    "icon": "wine-glass",
    "class": "fa-wine-glass",
    "group": "Alimentação"
  },
  {
    "name": "Beer",
    "icon": "beer",
    "class": "fa-beer",
    "group": "Alimentação"
  },
  {
    "name": "Cocktail",
    "icon": "cocktail",
    "class": "fa-cocktail",
    "group": "Alimentação"
  },
  {
    "name": "Glass Martini",
    "icon": "glass-martini",
    "class": "fa-glass-martini",
    "group": "Alimentação"
  },
  {
    "name": "Mug Hot",
    "icon": "mug-hot",
    "class": "fa-mug-hot",
    "group": "Alimentação"
  },
  {
    "name": "Car",
    "icon": "car",
    "class": "fa-car",
    "group": "Transporte"
  },
  {
    "name": "Bus",
    "icon": "bus",
    "class": "fa-bus",
    "group": "Transporte"
  },
  {
    "name": "Bicycle",
    "icon": "bicycle",
    "class": "fa-bicycle",
    "group": "Transporte"
  },
  {
    "name": "Motorcycle",
    "icon": "motorcycle",
    "class": "fa-motorcycle",
    "group": "Transporte"
  },
  {
    "name": "Plane",
    "icon": "plane",
    "class": "fa-plane",
    "group": "Transporte"
  },
  {
    "name": "Train",
    "icon": "train",
    "class": "fa-train",
    "group": "Transporte"
  },
  {
    "name": "Ship",
    "icon": "ship",
    "class": "fa-ship",
    "group": "Transporte"
  },
  {
    "name": "Subway",
    "icon": "subway",
    "class": "fa-subway",
    "group": "Transporte"
  },
  {
    "name": "Gas Pump",
    "icon": "gas-pump",
    "class": "fa-gas-pump",
    "group": "Transporte"
  },
  {
    "name": "Taxi",
    "icon": "taxi",
    "class": "fa-taxi",
    "group": "Transporte"
  },
  {
    "name": "Truck",
    "icon": "truck",
    "class": "fa-truck",
    "group": "Transporte"
  },
  {
    "name": "Helicopter",
    "icon": "helicopter",
    "class": "fa-helicopter",
    "group": "Transporte"
  },
  {
    "name": "Charging Station",
    "icon": "charging-station",
    "class": "fa-charging-station",
    "group": "Transporte"
  },
  {
    "name": "Map",
    "icon": "map",
    "class": "fa-map",
    "group": "Transporte"
  },
  {
    "name": "Road",
    "icon": "road",
    "class": "fa-road",
    "group": "Transporte"
  },
  {
    "name": "Parking",
    "icon": "parking",
    "class": "fa-parking",
    "group": "Transporte"
  },
  {
    "name": "Street View",
    "icon": "street-view",
    "class": "fa-street-view",
    "group": "Transporte"
  },
  {
    "name": "Walking",
    "icon": "walking",
    "class": "fa-walking",
    "group": "Transporte"
  },
  {
    "name": "Traffic Light",
    "icon": "traffic-light",
    "class": "fa-traffic-light",
    "group": "Transporte"
  },
  {
    "name": "Shuttle Van",
    "icon": "shuttle-van",
    "class": "fa-shuttle-van",
    "group": "Transporte"
  },
  {
    "name": "Home",
    "icon": "home",
    "class": "fa-home",
    "group": "Moradia"
  },
  {
    "name": "Bed",
    "icon": "bed",
    "class": "fa-bed",
    "group": "Moradia"
  },
  {
    "name": "Couch",
    "icon": "couch",
    "class": "fa-couch",
    "group": "Moradia"
  },
  {
    "name": "Bath",
    "icon": "bath",
    "class": "fa-bath",
    "group": "Moradia"
  },
  {
    "name": "Toilet",
    "icon": "toilet",
    "class": "fa-toilet",
    "group": "Moradia"
  },
  {
    "name": "Door Open",
    "icon": "door-open",
    "class": "fa-door-open",
    "group": "Moradia"
  },
  {
    "name": "Lightbulb",
    "icon": "lightbulb",
    "class": "fa-lightbulb",
    "group": "Moradia"
  },
  {
    "name": "Plug",
    "icon": "plug",
    "class": "fa-plug",
    "group": "Moradia"
  },
  {
    "name": "Shower",
    "icon": "shower",
    "class": "fa-shower",
    "group": "Moradia"
  },
  {
    "name": "Tv",
    "icon": "tv",
    "class": "fa-tv",
    "group": "Moradia"
  },
  {
    "name": "Tools",
    "icon": "tools",
    "class": "fa-tools",
    "group": "Moradia"
  },
  {
    "name": "Paint Roller",
    "icon": "paint-roller",
    "class": "fa-paint-roller",
    "group": "Moradia"
  },
  {
    "name": "Fan",
    "icon": "fan",
    "class": "fa-fan",
    "group": "Moradia"
  },
  {
    "name": "Chair",
    "icon": "chair",
    "class": "fa-chair",
    "group": "Moradia"
  },
  {
    "name": "Hammer",
    "icon": "hammer",
    "class": "fa-hammer",
    "group": "Moradia"
  },
  {
    "name": "Warehouse",
    "icon": "warehouse",
    "class": "fa-warehouse",
    "group": "Moradia"
  },
  {
    "name": "Water",
    "icon": "water",
    "class": "fa-water",
    "group": "Moradia"
  },
  {
    "name": "Fire Extinguisher",
    "icon": "fire-extinguisher",
    "class": "fa-fire-extinguisher",
    "group": "Moradia"
  },
  {
    "name": "Key",
    "icon": "key",
    "class": "fa-key",
    "group": "Moradia"
  },
  {
    "name": "Lock",
    "icon": "lock",
    "class": "fa-lock",
    "group": "Moradia"
  },
  {
    "name": "Film",
    "icon": "film",
    "class": "fa-film",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Gamepad",
    "icon": "gamepad",
    "class": "fa-gamepad",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Futbol",
    "icon": "futbol",
    "class": "fa-futbol",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Headphones",
    "icon": "headphones",
    "class": "fa-headphones",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Theater Masks",
    "icon": "theater-masks",
    "class": "fa-theater-masks",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Tv",
    "icon": "tv",
    "class": "fa-tv",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Music",
    "icon": "music",
    "class": "fa-music",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Book",
    "icon": "book",
    "class": "fa-book",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Camera",
    "icon": "camera",
    "class": "fa-camera",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Chess",
    "icon": "chess",
    "class": "fa-chess",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Dice",
    "icon": "dice",
    "class": "fa-dice",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Guitar",
    "icon": "guitar",
    "class": "fa-guitar",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Play",
    "icon": "play",
    "class": "fa-play",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Ticket Alt",
    "icon": "ticket-alt",
    "class": "fa-ticket-alt",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Puzzle Piece",
    "icon": "puzzle-piece",
    "class": "fa-puzzle-piece",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Palette",
    "icon": "palette",
    "class": "fa-palette",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Microphone",
    "icon": "microphone",
    "class": "fa-microphone",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Laugh",
    "icon": "laugh",
    "class": "fa-laugh",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Bowling Ball",
    "icon": "bowling-ball",
    "class": "fa-bowling-ball",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Drum",
    "icon": "drum",
    "class": "fa-drum",
    "group": "Lazer e Entretenimento"
  },
  {
    "name": "Book",
    "icon": "book",
    "class": "fa-book",
    "group": "Educação"
  },
  {
    "name": "Graduation Cap",
    "icon": "graduation-cap",
    "class": "fa-graduation-cap",
    "group": "Educação"
  },
  {
    "name": "Chalkboard Teacher",
    "icon": "chalkboard-teacher",
    "class": "fa-chalkboard-teacher",
    "group": "Educação"
  },
  {
    "name": "Pen",
    "icon": "pen",
    "class": "fa-pen",
    "group": "Educação"
  },
  {
    "name": "Pencil Alt",
    "icon": "pencil-alt",
    "class": "fa-pencil-alt",
    "group": "Educação"
  },
  {
    "name": "Highlighter",
    "icon": "highlighter",
    "class": "fa-highlighter",
    "group": "Educação"
  },
  {
    "name": "Laptop",
    "icon": "laptop",
    "class": "fa-laptop",
    "group": "Educação"
  },
  {
    "name": "Microscope",
    "icon": "microscope",
    "class": "fa-microscope",
    "group": "Educação"
  },
  {
    "name": "Atom",
    "icon": "atom",
    "class": "fa-atom",
    "group": "Educação"
  },
  {
    "name": "School",
    "icon": "school",
    "class": "fa-school",
    "group": "Educação"
  },
  {
    "name": "University",
    "icon": "university",
    "class": "fa-university",
    "group": "Educação"
  },
  {
    "name": "User Graduate",
    "icon": "user-graduate",
    "class": "fa-user-graduate",
    "group": "Educação"
  },
  {
    "name": "Notebook",
    "icon": "notebook",
    "class": "fa-notebook",
    "group": "Educação"
  },
  {
    "name": "Glasses",
    "icon": "glasses",
    "class": "fa-glasses",
    "group": "Educação"
  },
  {
    "name": "Calendar Alt",
    "icon": "calendar-alt",
    "class": "fa-calendar-alt",
    "group": "Educação"
  },
  {
    "name": "Paperclip",
    "icon": "paperclip",
    "class": "fa-paperclip",
    "group": "Educação"
  },
  {
    "name": "Folder",
    "icon": "folder",
    "class": "fa-folder",
    "group": "Educação"
  },
  {
    "name": "Ruler",
    "icon": "ruler",
    "class": "fa-ruler",
    "group": "Educação"
  },
  {
    "name": "Compass",
    "icon": "compass",
    "class": "fa-compass",
    "group": "Educação"
  },
  {
    "name": "Abacus",
    "icon": "abacus",
    "class": "fa-abacus",
    "group": "Educação"
  },
  {
    "name": "Heartbeat",
    "icon": "heartbeat",
    "class": "fa-heartbeat",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Stethoscope",
    "icon": "stethoscope",
    "class": "fa-stethoscope",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Medkit",
    "icon": "medkit",
    "class": "fa-medkit",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Pills",
    "icon": "pills",
    "class": "fa-pills",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Syringe",
    "icon": "syringe",
    "class": "fa-syringe",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Tooth",
    "icon": "tooth",
    "class": "fa-tooth",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Spa",
    "icon": "spa",
    "class": "fa-spa",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Dumbbell",
    "icon": "dumbbell",
    "class": "fa-dumbbell",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "First Aid",
    "icon": "first-aid",
    "class": "fa-first-aid",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Soap",
    "icon": "soap",
    "class": "fa-soap",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Thermometer",
    "icon": "thermometer",
    "class": "fa-thermometer",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Band Aid",
    "icon": "band-aid",
    "class": "fa-band-aid",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Apple Alt",
    "icon": "apple-alt",
    "class": "fa-apple-alt",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Lungs",
    "icon": "lungs",
    "class": "fa-lungs",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Brain",
    "icon": "brain",
    "class": "fa-brain",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "User Nurse",
    "icon": "user-nurse",
    "class": "fa-user-nurse",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Hospital",
    "icon": "hospital",
    "class": "fa-hospital",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Vial",
    "icon": "vial",
    "class": "fa-vial",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Weight",
    "icon": "weight",
    "class": "fa-weight",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Tint",
    "icon": "tint",
    "class": "fa-tint",
    "group": "Saúde e Cuidados Pessoais"
  },
  {
    "name": "Shopping Cart",
    "icon": "shopping-cart",
    "class": "fa-shopping-cart",
    "group": "Compras"
  },
  {
    "name": "Shopping Bag",
    "icon": "shopping-bag",
    "class": "fa-shopping-bag",
    "group": "Compras"
  },
  {
    "name": "Store",
    "icon": "store",
    "class": "fa-store",
    "group": "Compras"
  },
  {
    "name": "Tags",
    "icon": "tags",
    "class": "fa-tags",
    "group": "Compras"
  },
  {
    "name": "Credit Card",
    "icon": "credit-card",
    "class": "fa-credit-card",
    "group": "Compras"
  },
  {
    "name": "Cash Register",
    "icon": "cash-register",
    "class": "fa-cash-register",
    "group": "Compras"
  },
  {
    "name": "Receipt",
    "icon": "receipt",
    "class": "fa-receipt",
    "group": "Compras"
  },
  {
    "name": "Box",
    "icon": "box",
    "class": "fa-box",
    "group": "Compras"
  },
  {
    "name": "Gift",
    "icon": "gift",
    "class": "fa-gift",
    "group": "Compras"
  },
  {
    "name": "Cart Arrow Down",
    "icon": "cart-arrow-down",
    "class": "fa-cart-arrow-down",
    "group": "Compras"
  },
  {
    "name": "Barcode",
    "icon": "barcode",
    "class": "fa-barcode",
    "group": "Compras"
  },
  {
    "name": "Store Alt",
    "icon": "store-alt",
    "class": "fa-store-alt",
    "group": "Compras"
  },
  {
    "name": "Bag Shopping",
    "icon": "bag-shopping",
    "class": "fa-bag-shopping",
    "group": "Compras"
  },
  {
    "name": "Percent",
    "icon": "percent",
    "class": "fa-percent",
    "group": "Compras"
  },
  {
    "name": "Wallet",
    "icon": "wallet",
    "class": "fa-wallet",
    "group": "Compras"
  },
  {
    "name": "Money Bill",
    "icon": "money-bill",
    "class": "fa-money-bill",
    "group": "Compras"
  },
  {
    "name": "Price Tag",
    "icon": "price-tag",
    "class": "fa-price-tag",
    "group": "Compras"
  },
  {
    "name": "Dollar Sign",
    "icon": "dollar-sign",
    "class": "fa-dollar-sign",
    "group": "Compras"
  },
  {
    "name": "Coins",
    "icon": "coins",
    "class": "fa-coins",
    "group": "Compras"
  },
  {
    "name": "Exchange Alt",
    "icon": "exchange-alt",
    "class": "fa-exchange-alt",
    "group": "Compras"
  },
  {
    "name": "Briefcase",
    "icon": "briefcase",
    "class": "fa-briefcase",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Money Bill Wave",
    "icon": "money-bill-wave",
    "class": "fa-money-bill-wave",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Wallet",
    "icon": "wallet",
    "class": "fa-wallet",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Chart Line",
    "icon": "chart-line",
    "class": "fa-chart-line",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Hand Holding Usd",
    "icon": "hand-holding-usd",
    "class": "fa-hand-holding-usd",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Business Time",
    "icon": "business-time",
    "class": "fa-business-time",
    "group": "Trabalho e Renda"
  },
  {
    "name": "User Tie",
    "icon": "user-tie",
    "class": "fa-user-tie",
    "group": "Trabalho e Renda"
  },
  {
    "name": "File Invoice",
    "icon": "file-invoice",
    "class": "fa-file-invoice",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Calculator",
    "icon": "calculator",
    "class": "fa-calculator",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Suitcase",
    "icon": "suitcase",
    "class": "fa-suitcase",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Landmark",
    "icon": "landmark",
    "class": "fa-landmark",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Piggy Bank",
    "icon": "piggy-bank",
    "class": "fa-piggy-bank",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Clipboard",
    "icon": "clipboard",
    "class": "fa-clipboard",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Money Check",
    "icon": "money-check",
    "class": "fa-money-check",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Balance Scale",
    "icon": "balance-scale",
    "class": "fa-balance-scale",
    "group": "Trabalho e Renda"
  },
  {
    "name": "File Contract",
    "icon": "file-contract",
    "class": "fa-file-contract",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Chart Pie",
    "icon": "chart-pie",
    "class": "fa-chart-pie",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Id Badge",
    "icon": "id-badge",
    "class": "fa-id-badge",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Project Diagram",
    "icon": "project-diagram",
    "class": "fa-project-diagram",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Users",
    "icon": "users",
    "class": "fa-users",
    "group": "Trabalho e Renda"
  },
  {
    "name": "Hand Holding Usd",
    "icon": "hand-holding-usd",
    "class": "fa-hand-holding-usd",
    "group": "Receita"
  },
  {
    "name": "Money Bill Wave",
    "icon": "money-bill-wave",
    "class": "fa-money-bill-wave",
    "group": "Receita"
  },
  {
    "name": "Wallet",
    "icon": "wallet",
    "class": "fa-wallet",
    "group": "Receita"
  },
  {
    "name": "Chart Line",
    "icon": "chart-line",
    "class": "fa-chart-line",
    "group": "Receita"
  },
  {
    "name": "Donate",
    "icon": "donate",
    "class": "fa-donate",
    "group": "Receita"
  },
  {
    "name": "Credit Card",
    "icon": "credit-card",
    "class": "fa-credit-card",
    "group": "Receita"
  },
  {
    "name": "Dollar Sign",
    "icon": "dollar-sign",
    "class": "fa-dollar-sign",
    "group": "Receita"
  },
  {
    "name": "Coins",
    "icon": "coins",
    "class": "fa-coins",
    "group": "Receita"
  },
  {
    "name": "Piggy Bank",
    "icon": "piggy-bank",
    "class": "fa-piggy-bank",
    "group": "Receita"
  },
  {
    "name": "Money Check",
    "icon": "money-check",
    "class": "fa-money-check",
    "group": "Receita"
  },
  {
    "name": "File Invoice Dollar",
    "icon": "file-invoice-dollar",
    "class": "fa-file-invoice-dollar",
    "group": "Receita"
  },
  {
    "name": "Landmark",
    "icon": "landmark",
    "class": "fa-landmark",
    "group": "Receita"
  },
  {
    "name": "User Tie",
    "icon": "user-tie",
    "class": "fa-user-tie",
    "group": "Receita"
  },
  {
    "name": "Money Check Alt",
    "icon": "money-check-alt",
    "class": "fa-money-check-alt",
    "group": "Receita"
  },
  {
    "name": "Receipt",
    "icon": "receipt",
    "class": "fa-receipt",
    "group": "Receita"
  },
  {
    "name": "Cash Register",
    "icon": "cash-register",
    "class": "fa-cash-register",
    "group": "Receita"
  },
  {
    "name": "Balance Scale",
    "icon": "balance-scale",
    "class": "fa-balance-scale",
    "group": "Receita"
  },
  {
    "name": "Briefcase",
    "icon": "briefcase",
    "class": "fa-briefcase",
    "group": "Receita"
  },
  {
    "name": "Chart Pie",
    "icon": "chart-pie",
    "class": "fa-chart-pie",
    "group": "Receita"
  },
  {
    "name": "Building",
    "icon": "building",
    "class": "fa-building",
    "group": "Receita"
  },
  {
    "name": "Laptop",
    "icon": "laptop",
    "class": "fa-laptop",
    "group": "Tecnologia"
  },
  {
    "name": "Mobile Alt",
    "icon": "mobile-alt",
    "class": "fa-mobile-alt",
    "group": "Tecnologia"
  },
  {
    "name": "Tablet Alt",
    "icon": "tablet-alt",
    "class": "fa-tablet-alt",
    "group": "Tecnologia"
  },
  {
    "name": "Desktop",
    "icon": "desktop",
    "class": "fa-desktop",
    "group": "Tecnologia"
  },
  {
    "name": "Server",
    "icon": "server",
    "class": "fa-server",
    "group": "Tecnologia"
  },
  {
    "name": "Wifi",
    "icon": "wifi",
    "class": "fa-wifi",
    "group": "Tecnologia"
  },
  {
    "name": "Satellite",
    "icon": "satellite",
    "class": "fa-satellite",
    "group": "Tecnologia"
  },
  {
    "name": "Microchip",
    "icon": "microchip",
    "class": "fa-microchip",
    "group": "Tecnologia"
  },
  {
    "name": "Keyboard",
    "icon": "keyboard",
    "class": "fa-keyboard",
    "group": "Tecnologia"
  },
  {
    "name": "Mouse",
    "icon": "mouse",
    "class": "fa-mouse",
    "group": "Tecnologia"
  },
  {
    "name": "Camera",
    "icon": "camera",
    "class": "fa-camera",
    "group": "Tecnologia"
  },
  {
    "name": "Tv",
    "icon": "tv",
    "class": "fa-tv",
    "group": "Tecnologia"
  },
  {
    "name": "Code",
    "icon": "code",
    "class": "fa-code",
    "group": "Tecnologia"
  },
  {
    "name": "Cloud",
    "icon": "cloud",
    "class": "fa-cloud",
    "group": "Tecnologia"
  },
  {
    "name": "Database",
    "icon": "database",
    "class": "fa-database",
    "group": "Tecnologia"
  },
  {
    "name": "Network Wired",
    "icon": "network-wired",
    "class": "fa-network-wired",
    "group": "Tecnologia"
  },
  {
    "name": "Robot",
    "icon": "robot",
    "class": "fa-robot",
    "group": "Tecnologia"
  },
  {
    "name": "Usb",
    "icon": "usb",
    "class": "fa-usb",
    "group": "Tecnologia"
  },
  {
    "name": "Ethernet",
    "icon": "ethernet",
    "class": "fa-ethernet",
    "group": "Tecnologia"
  },
  {
    "name": "Sim Card",
    "icon": "sim-card",
    "class": "fa-sim-card",
    "group": "Tecnologia"
  },
{
    "name": "Assinaturas",
    "icon": "file-invoice",
    "class": "fa-file-invoice",
    "group": "Serviços"
  },
  {
    "name": "Contador/Impostos",
    "icon": "receipt",
    "class": "fa-receipt",
    "group": "Serviços"
  },
  {
    "name": "Multas e taxas",
    "icon": "gavel",
    "class": "fa-gavel",
    "group": "Serviços"
  },
  {
    "name": "Serviços bancários",
    "icon": "university",
    "class": "fa-university",
    "group": "Serviços"
  },
  {
    "name": "Presentes",
    "icon": "gift",
    "class": "fa-gift",
    "group": "Outros"
  },
  {
    "name": "Doações",
    "icon": "hand-holding-heart",
    "class": "fa-hand-holding-heart",
    "group": "Outros"
  },
  {
    "name": "Imprevistos",
    "icon": "exclamation-triangle",
    "class": "fa-exclamation-triangle",
    "group": "Outros"
  }
]


const getIcons = async () => {

    let mapped_groups = {};

    icons_new.forEach((item) => {

        if(mapped_groups[item.group]){

            mapped_groups[item.group].push(item);

        }
        else{
            mapped_groups[item.group] = [];
            mapped_groups[item.group].push(item);
        }

    });

    icons = mapped_groups;

}

const store = useStore();

const darkMode = computed(() => store.state.darkMode);

const parseMoneyValue = (value) => {
    if (value === null || value === undefined || value === '') return 0;
    if (typeof value === 'number') return value;

    const stringValue = String(value).trim();

    // Formato BR: 2.421,39
    if (stringValue.includes(',') && stringValue.includes('.')) {
        return Number(stringValue.replace(/\./g, '').replace(',', '.')) || 0;
    }

    // Formato BR simples: 2421,39
    if (stringValue.includes(',')) {
        return Number(stringValue.replace(',', '.')) || 0;
    }

    // Formato API/EN: 2421.39
    return Number(stringValue) || 0;
}

const getObjectiveCurrentValue = (objetive) => {
    return parseMoneyValue(objetive?.balance);
}

const totalObjetives = computed(() => Array.isArray(store.state.objetives) ? store.state.objetives.length : 0);
const totalTargetAmount = computed(() => (store.state.objetives || []).reduce((acc, item) => acc + parseMoneyValue(item?.target), 0));
const totalSavedAmount = computed(() =>
    (store.state.objetives || []).reduce((acc, item) => acc + parseMoneyValue(item?.balance), 0)
);
const completionPercentage = computed(() => {
    if (!totalTargetAmount.value) return 0;
    return Math.min(100, Math.round((totalSavedAmount.value / totalTargetAmount.value) * 100));
});
const reachedObjetives = computed(() => (store.state.objetives || []).filter((item) => getObjectiveCurrentValue(item) >= parseMoneyValue(item?.target) && parseMoneyValue(item?.target) > 0).length);
const remainingAmount = computed(() =>
    Math.max(0, totalTargetAmount.value - totalSavedAmount.value)
);
const pendingDeleteObjetive = computed(() => store.state.toArchive || {});

onBeforeMount(() => {

    validSession.isLogged();

    store.state.transaction_value = {
        value: 0
    }

    store.state.objetive_icon = 'fa-receipt';
    store.state.objetive_color = '#000'
    store.state.objetive_name = '';
    store.state.objetive_target = 0;
    store.state.objetive_discount = 0;
    store.state.objetive_account = 0;
    store.state.objetive_id = '';

    store.state.accounts = [];
    store.state.objetives = [];
    
    store.state.loadingObjetives = true;
    store.state.savingObjetive = false;

    store.state.savingTransaction = false;

    store.state.validation = {
        nameHasError: false,
        nameMessageError: '',
        accountHasError: false,
        accountMessageError: '',
    };

    store.state.deleted_category = {};
    store.state.destiny_category = 0;

    store.state.toArchive = {
        icon: '',
        name: '',
    };

    let day = new Date().getDate();
    let month = new Date().getMonth() + 1;
    let year = new Date().getFullYear();

    store.state.current_date = year+ '-' + (month < 10 ? '0'+month : month) + '-' + (day < 10 ? '0'+ day : day);

    store.state.transation = {
        type: '',
        amount: 0,
        date: store.state.current_date,
        objetive_id: 0,
        objetive_name: ''
    }

    store.state.modalColor = '';

    getObjetives();
    getIcons();
    getAccounts();
    
});

const clearFields = () => {
    store.state.objetive_icon = 'fa-receipt';
    store.state.objetive_color = '#000'
    store.state.objetive_name = '';
    store.state.objetive_target = 0;
    store.state.objetive_discount = 0;
    store.state.objetive_account = 0;
    store.state.objetive_id = '';
}

const openModal = (id) => {

    let modal = bootstrap.Modal.getOrCreateInstance(document.getElementById(id));

    modal.show();

}

const getContrastYIQ = (hexcolor) => {
    var r = parseInt(hexcolor.substring(1,3),16);
    var g = parseInt(hexcolor.substring(3,5),16);
    var b = parseInt(hexcolor.substring(5,7),16);
    var yiq = ((r*299)+(g*587)+(b*114))/1000;
    return (yiq >= 128) ? 'black' : 'white';
}

const getAccounts = async () => {

    axios.get('accounts?archived=No')
    .then(res => {
        
        if(res.status == 200){

            store.state.accounts = res.data;

        }
        
    })
    .catch(err => {
        console.error(err); 
    })

}

const getObjetives = async () => {

    store.state.loadingObjetives = true;

    axios.get('objetives')
    .then(res => {
        
        if(res.status == 200){

            store.state.objetives = res.data;
            store.state.loadingObjetives = false;

        }
        
    })
    .catch(err => {
        console.error(err); 
    })

}

const closeModal = (id) => {

    let modal = bootstrap.Modal.getOrCreateInstance(document.getElementById(id));

    modal.hide();

}

const submit_objetive = async () => {

    let data = new FormData();

    store.state.validation.nameHasError = false;
    store.state.validation.accountHasError = false;

    store.state.objetive_target = value_objetive.value.replace('R$ ', '');

    data.append('name', store.state.objetive_name);
    data.append('icon', store.state.objetive_icon);
    data.append('color', store.state.objetive_color);
    data.append('target', store.state.objetive_target);
    data.append('discount', store.state.objetive_discount == true ? 'Yes' : 'No');
    data.append('account_id', store.state.objetive_discount == true ? store.state.objetive_account : 0);

    let url = '/objetives';
    let toast_message = 'Objetivo criado com sucesso!';

    if(store.state.objetive_id != ''){
        url = '/objetives/update/'+store.state.objetive_id;
        toast_message = 'Objetivo atualizado com sucesso!';
    }

    await axios.post(url, data)
    .then(res => {

        if(res.data.error){

            let messages = res.data.messages;

            Object.entries(messages).forEach((value) => {

                if(value[0] == 'name'){
                    store.state.validation.nameHasError = true;
                    store.state.validation.nameMessageError = value[1];
                }

                else if(value[0] == 'parent_id'){
                    store.state.validation.parentHasError = true;
                    store.state.validation.parentMessageError = value[1];
                }


            })

        }
        else{

            store.state.validation = {
                nameHasError: false,
                nameMessageError: '',
                accountHasError: false,
                accountMessageError: '',
            };

            closeModal('addObjetiveModal');

            clearFields();

            getObjetives();

            toast(toast_message, {
                autoClose: 1000,
                theme: "auto",
                type: "success",
                transition: "slide"
            });

        }

    })
    .catch(err => {
    console.error(err); 
    })

}

const editObjetive = (data) => {

    value_objetive.value = formatMoney(data.target);

    store.state.objetive_icon = data.icon;
    store.state.objetive_color = data.color
    store.state.objetive_name = data.name;
    store.state.objetive_target = data.target;
    store.state.objetive_discount =  data.discount == 'Yes' ? true : false;
    store.state.objetive_account = data.account_id;
    store.state.objetive_id = data.id;

}

function formatMoney(v) {
      let total = parseFloat(v);

      return total.toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL",
      });
}

const deleteObjetive = async (objetive) => {

    store.state.toArchive = {
        id: objetive.id,
        icon: objetive.icon,
        name: objetive.name,
    };

    openModal('deleteObjetive');

}

const confirmDeleteObjetive = async () => {

    if(!store.state.toArchive?.id){
        closeModal('deleteObjetive');
        return;
    }

    let url = '/objetives/delete/'+store.state.toArchive.id;
    let toast_message = 'Objetivo excluído com sucesso!';

    await axios.post(url)
    .then(res => {

        if(res.data.error){
            console.log(res);
        }
        else{

            toast(toast_message, {
                autoClose: 1000,
                theme: "auto",
                type: "success",
                transition: "slide"
            });

            closeModal('deleteObjetive');
            getObjetives();
            store.state.toArchive = {};

        }

    })
    .catch(err => {
        console.error(err); 
    })

}

const setTypeObj = (data, type) => {

    if(type == 'retirada'){
        store.state.modalColor = '-warning';
    }
    else if(type == 'deposito'){
        store.state.modalColor = '-success';
    }

    store.state.transation.type = type;
    store.state.transation.objetive_id = data.id;
    store.state.transation.objetive_name = data.name;

}

const clearFieldsTransaction = () => {

    store.state.transation = {
        type: '',
        amount: 0,
        date: store.state.current_date,
        objetive_id: 0,
        objetive_name: ''
    }

    store.state.transaction_value = {
        value: 0
    }

}

const submitTransaction = async () => {

    store.state.savingTransaction = true;

    let data = new FormData();

    store.state.transation.amount = store.state.transaction_value.value.replace('R$ ', '');

    //console.log(store.state.transation.amount);

    data.append('type', store.state.transation.type);
    data.append('amount', store.state.transation.amount);
    data.append('date', store.state.transation.date);
    data.append('objetive_id', store.state.transation.objetive_id);

    let url = '/objetives/transactions';
    let toast_message = 'Transação criado com sucesso!';

    await axios.post(url, data)
    .then(res => {

        if(res.data.error){

            let messages = res.data.messages;

            Object.entries(messages).forEach((value) => {

                if(value[0] == 'description'){
                    store.state.validation.descHasError = true;
                    store.state.validation.descMessageError = value[1];
                }
                else if(value[0] == 'account'){
                    store.state.validation.accountError = true;
                    store.state.validation.accountMessageError = value[1];
                }
                else if(value[0] == 'category'){
                    store.state.validation.categorryError = true;
                    store.state.validation.categoryMessageError = value[1];
                }

            })

            store.state.savingTransaction = false;

        }
        else{

            store.state.validation = {
                descHasError: false,
                descMessageError: '',
            };

            closeModal('addTransactionObj');

            toast(toast_message, {
                autoClose: 1000,
                theme: "auto",
                type: "success",
                transition: "slide"
            });

            store.state.savingTransaction = false;

            getObjetives();
            clearFieldsTransaction();

        }

    })
    .catch(err => {
        console.error(err); 

        toast('Não foi possível realizar a operação, tente mais tarde (Erro '+err.response.status+')', {
            autoClose: 1000,
            theme: "auto",
            type: "error",
            transition: "slide"
        });

        store.state.savingTransaction = false;

    })

}

</script>

<template>
    <div class="objetives-page py-4 container-fluid" :class="darkMode ? 'darkmode' : ''">

        <section class="objetives-hero card border-0 shadow-sm mb-4">
            <div class="card-body p-4 p-lg-5">
                <div class="row align-items-center g-4">
                    <div class="col-12 col-xl-7">
                        <div class="d-flex align-items-start gap-3">
                            <div class="hero-icon-wrap">
                                <i class="fal fa-bullseye-arrow"></i>
                            </div>
                            <div>
                                <span class="eyebrow">Planejamento financeiro</span>
                                <h2 class="hero-title mb-2">Objetivos</h2>
                                <p class="hero-subtitle mb-0">
                                    Acompanhe suas metas, veja o quanto já acumulou e movimente cada objetivo com mais clareza.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-xl-5">
                        <div class="d-flex flex-column flex-sm-row justify-content-xl-end gap-2">
                            <button
                                class="btn objective-header-btn objective-refresh-btn"
                                type="button"
                                @click="getObjetives()"
                            >
                                <i class="fal fa-rotate-right me-2"></i>Atualizar
                            </button>
                            <button
                                class="btn objective-header-btn objective-add-btn"
                                type="button"
                                @click="openModal('addObjetiveModal')"
                            >
                                <i class="fal fa-plus me-2"></i>Adicionar objetivo
                            </button>
                        </div>
                    </div>
                </div>

                <div class="row g-3 mt-2 mt-lg-4 objective-summary-row">
                    <div class="col-6 col-md-6 col-xl-3">
                        <div class="summary-card">
                            <span class="summary-label">Objetivos ativos</span>
                            <strong class="summary-value">{{ totalObjetives }}</strong>
                            <small class="summary-helper">{{ reachedObjetives }} concluídos</small>
                        </div>
                    </div>
                    <div class="col-6 col-md-6 col-xl-3">
                        <div class="summary-card">
                            <span class="summary-label">Total planejado</span>
                            <strong class="summary-value">{{ formatMoney(totalTargetAmount) }}</strong>
                            <small class="summary-helper">Soma das metas cadastradas</small>
                        </div>
                    </div>
                    <div class="col-6 col-md-6 col-xl-3">
                        <div class="summary-card">
                            <span class="summary-label">Já acumulado</span>
                            <strong class="summary-value">{{ formatMoney(totalSavedAmount) }}</strong>
                            <small class="summary-helper">{{ completionPercentage }}% do total planejado</small>
                        </div>
                    </div>
                    <div class="col-6 col-md-6 col-xl-3">
                        <div class="summary-card">
                            <span class="summary-label">Falta atingir</span>
                            <strong class="summary-value">{{ formatMoney(remainingAmount) }}</strong>
                            <small class="summary-helper">Valor restante para concluir tudo</small>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="card border-0 shadow-sm objectives-list-card">
            <div class="card-body p-3 p-lg-4">
                <div class="d-flex flex-column flex-lg-row align-items-lg-center justify-content-between gap-3 mb-3">
                    <div>
                        <h5 class="mb-1">Seus objetivos</h5>
                        <p class="text-muted mb-0">Visualize o progresso e faça depósitos ou retiradas rapidamente.</p>
                    </div>
                    <div class="objectives-progress-chip">
                        <span>Progresso geral</span>
                        <strong>{{ completionPercentage }}%</strong>
                    </div>
                </div>

                <div class="overall-progress mb-4">
                    <div class="overall-progress-bar" :style="{ width: completionPercentage + '%' }"></div>
                </div>

                <div class="col-12 text-center py-5" v-if="store.state.loadingObjetives">
                    <img :src="loadGif" alt="Carregando objetivos" width="56">
                    <p class="text-muted mt-3 mb-0">Carregando seus objetivos...</p>
                </div>

                <div class="empty-state text-center py-5" v-else-if="store.state.objetives.length == 0">
                    <div class="empty-state-icon mx-auto mb-3">
                        <i class="fal fa-bullseye-arrow"></i>
                    </div>
                    <h5 class="mb-2">Nenhum objetivo cadastrado</h5>
                    <p class="text-muted mb-4">Crie seu primeiro objetivo para começar a organizar metas e acompanhar sua evolução.</p>
                    <button class="btn objective-header-btn objective-add-btn" type="button" @click="openModal('addObjetiveModal')">
                        <i class="fal fa-plus me-2"></i>Criar primeiro objetivo
                    </button>
                </div>

                <div class="objectives-grid" v-else>
                    <ObjetivesRow
                        v-for="(objetive, index) in store.state.objetives" :key="index"
                        :objetive="objetive"
                        :id="objetive.id"
                        :darkmode="darkMode"
                        @edit="editObjetive"
                        @setType="setTypeObj"
                        @delete="deleteObjetive"
                    />
                </div>
            </div>
        </section>
    </div>

    <div class="modal fade" id="addObjetiveModal" tabindex="-1" aria-hidden="true" data-bs-backdrop="static">
        <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable objective-create-modal-dialog">
            <div class="modal-content objective-modal"
                v-bind:class="{
                        'darkmode': darkMode,
                    }"
            >
                <div class="objective-modal-header">
                    <div>
                        <h4>
                            {{ store.state.objetive_id == '' ? 'Criar objetivo' : 'Editar objetivo' }}
                        </h4>
                        <span>Defina sua meta e personalize seu objetivo.</span>
                    </div>

                    <button
                        type="button"
                        class="objective-close"
                        data-bs-dismiss="modal"
                        @click="clearFields()"
                    >
                        <i class="fal fa-times"></i>
                    </button>
                </div>

                <div class="objective-modal-body">
                    <div class="objective-preview">
                        <div
                            class="preview-icon"
                            :style="'background-color: '+`${store.state.objetive_color}20`"
                        >
                            <i
                                :class="'fal '+store.state.objetive_icon"
                                :style="{ color: store.state.objetive_color}"
                            ></i>
                        </div>
                        <span>Pré-visualização</span>
                    </div>

                    <div class="objective-form-card">
                        <div class="row g-3">
                            <div class="col-12">
                                <label class="objective-field-label">Nome do objetivo</label>
                                <input
                                    v-model="store.state.objetive_name"
                                    class="form-control input-modern"
                                    placeholder="Nome do objetivo"
                                    v-bind:class="{
                                        'is-invalid': store.state.validation.nameHasError,
                                        'darkmode': darkMode,
                                    }"
                                />
                                <div id="objetiveNameFeedback" class="invalid-feedback">
                                    {{ store.state.validation.nameMessageError }}
                                </div>
                            </div>

                            <div class="col-12">
                                <label class="objective-field-label">Meta do objetivo</label>
                                <input
                                    type="tel"
                                    v-model.lazy="value_objetive.value"
                                    v-money="money"
                                    class="form-control input-modern"
                                    v-bind:class="{
                                        'darkmode': darkMode,
                                    }"
                                />
                            </div>

                            <div class="col-12">
                                <div class="switch-row">
                                    <div>
                                        <strong>Transação automática</strong>
                                        <small>Vincular esse objetivo a uma conta.</small>
                                    </div>

                                    <label class="switch">
                                        <input type="checkbox" v-model="store.state.objetive_discount">
                                        <span></span>
                                    </label>
                                </div>
                            </div>

                            <div class="col-12" v-if="store.state.objetive_discount">
                                <label class="objective-field-label">Criar transação na conta</label>
                                <select
                                    v-model="store.state.objetive_account"
                                    class="form-select input-modern"
                                    v-bind:class="{
                                        'is-invalid': store.state.validation.accountError,
                                        'darkmode': darkMode,
                                    }"
                                >
                                    <option value="0" selected disabled>Selecione a conta</option>
                                    <option
                                        v-for="(account, index) in store.state.accounts"
                                        :key="account?.id || index"
                                        :value="account?.id"
                                    >
                                        {{ account?.name || 'Conta sem nome' }}
                                    </option>
                                </select>
                                <div id="accountSelectFeedback" class="invalid-feedback">
                                    {{ store.state.validation.accountMessageError }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="objective-section">
                        <div class="objective-section-head">
                            <h5>Escolha um ícone</h5>
                            <span>{{ store.state.objetive_icon }}</span>
                        </div>

                        <div class="objective-icons-wrapper">
                            <div v-for="(groups, index) in icons" :key="index" class="objective-icon-group">
                                <div class="objective-group-title">{{ index }}</div>

                                <div class="objective-icon-grid">
                                    <button
                                        type="button"
                                        v-for="(icon, i) in groups"
                                        :key="i"
                                        @click="store.state.objetive_icon = icon.class"
                                        :class="['icon-item', { active: store.state.objetive_icon === icon.class }]"
                                    >
                                        <i :class="'fal '+icon.class"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="objective-section">
                        <div class="objective-section-head">
                            <h5>Escolha uma cor</h5>
                            <span>{{ store.state.objetive_color }}</span>
                        </div>

                        <div class="color-grid">
                            <button
                                type="button"
                                v-for="color in colors"
                                :key="color"
                                @click="store.state.objetive_color = color"
                                :style="'background:'+color"
                                :class="['color-item', { active: store.state.objetive_color === color }]"
                            ></button>
                        </div>
                    </div>
                </div>

                <div class="objective-footer">
                    <button class="btn-save" @click="submit_objetive()">
                        {{ store.state.objetive_id == '' ? 'Criar objetivo' : 'Salvar alterações' }}
                    </button>
                </div>
            </div>
        </div>
    </div>
    
    <div class="modal fade" id="deleteObjetive" tabindex="-1" aria-labelledby="deleteObjetiveModal" aria-hidden="true" data-bs-backdrop="static">
        <div class="modal-dialog modal-dialog-centered objective-delete-modal">
            <div class="modal-content objective-delete-modal-content"
                v-bind:class="{
                            'darkmode': darkMode,
                        }"
            >
                <div class="modal-body objective-delete-modal-body" :class="darkMode ? 'darkmode' : ''">
                    <div class="objective-delete-header">
                        <div>
                            <div class="objective-delete-kicker">Confirmação</div>
                            <h5 class="objective-delete-title mb-0">Excluir objetivo</h5>
                        </div>

                        <button
                            type="button"
                            class="objective-delete-close"
                            data-bs-dismiss="modal"
                            @click="closeModal('deleteObjetive')"
                            aria-label="Fechar"
                        >
                            <i class="fal fa-times"></i>
                        </button>
                    </div>

                    <div class="objective-delete-card">
                        <div class="objective-delete-icon">
                            <i class="fal fa-trash-alt"></i>
                        </div>

                        <div class="objective-delete-copy">
                            <h6>{{ pendingDeleteObjetive.name || "este objetivo" }}</h6>
                            <p class="mb-0">
                                Tem certeza que deseja excluir este objetivo? Essa ação é permanente e não poderá ser desfeita.
                            </p>
                        </div>
                    </div>

                    <div class="objective-delete-actions">
                        <button
                            type="button"
                            class="btn objective-delete-cancel"
                            data-bs-dismiss="modal"
                            @click="closeModal('deleteObjetive')"
                        >
                            Cancelar
                        </button>

                        <button
                            id="confirmExclusionObjetiveButton"
                            type="button"
                            class="btn objective-delete-confirm"
                            @click="confirmDeleteObjetive()"
                        >
                            Excluir permanentemente
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" id="addTransactionObj" tabindex="-1" aria-labelledby="addTransactionObj" aria-hidden="true" data-bs-backdrop="static">
        <div class="modal-dialog modal-dialog-centered objective-transaction-modal-dialog">
            <div class="modal-content objective-modal"
                v-bind:class="{
                    'darkmode': darkMode,
                }"
            >
                <div class="objective-modal-header">
                    <div>
                        <div class="objective-transaction-kicker">
                            {{ store.state.transation.type == 'deposito' ? 'Novo depósito' : 'Nova retirada' }}
                        </div>
                        <h4 class="mb-0">
                            {{ store.state.transation.type == 'deposito' ? 'Novo depósito em ' : 'Nova retirada em ' }}{{ store.state.transation.objetive_name || 'Objetivo' }}
                        </h4>
                    </div>

                    <button
                        type="button"
                        class="objective-close"
                        data-bs-dismiss="modal"
                        @click="clearFieldsTransaction()"
                        aria-label="Fechar"
                    >
                        <i class="fal fa-times"></i>
                    </button>
                </div>

                <div class="objective-modal-body">
                    <div class="objective-form-card mb-0">
                        <div class="objective-transaction-grid">
                            <div class="objective-transaction-field">
                                <label class="objective-field-label" for="transactionAmount">Valor</label>
                                <input 
                                    type="tel" 
                                    class="form-control input-modern" 
                                    id="transactionAmount"
                                    name="transactionAmount"
                                    v-model.lazy="store.state.transaction_value.value" 
                                    v-money="money"
                                    v-bind:class="{
                                        'darkmode': darkMode,
                                    }"
                                >
                            </div>

                            <div class="objective-transaction-field">
                                <label class="objective-field-label" for="transactionDate">Data</label>
                                <div class="objective-date-wrap">
                                    <FlatPickr
                                        v-model="store.state.transation.date"
                                        :config="{
                                            altInput: true,
                                            altFormat: 'd/m/Y',
                                            dateFormat: 'Y-m-d',
                                            locale: Portuguese,
                                            allowInput: true,
                                            clickOpens: true
                                        }"
                                        class="form-control input-modern objective-date-input"
                                        id="transactionDate"
                                    />
                                    <button
                                        type="button"
                                        class="objective-date-trigger"
                                        @click.prevent="$event.currentTarget.parentElement.querySelector('input').focus()"
                                        tabindex="-1"
                                        aria-hidden="true"
                                    >
                                        <i class="fal fa-calendar-alt"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="objective-footer objective-transaction-footer">
                    <button
                        v-if="!store.state.savingTransaction"
                        @click="submitTransaction()"
                        class="btn btn-save objective-transaction-save"
                        :class="store.state.transation.type == 'deposito' ? 'is-deposit' : 'is-withdraw'"
                    >
                        Salvar
                    </button>
                    <img v-if="store.state.savingTransaction" :src="loadGif" alt="" width="50">
                </div>
            </div>
        </div>
    </div>

</template>

<style scoped>
.objetives-page {
    background: linear-gradient(180deg, rgba(245, 241, 232, 0.55) 0%, rgba(245, 241, 232, 0) 240px);
    position: relative;
}

.objetives-hero {
    border-radius: 28px;
    background: linear-gradient(135deg, #1f4268 0%, #294d78 55%, #2f5c91 100%);
    color: #fff;
    overflow: hidden;
}

.objetives-hero::after {
    content: "";
    position: absolute;
    inset: auto -80px -80px auto;
    width: 220px;
    height: 220px;
    background: radial-gradient(circle, rgba(255,255,255,0.18) 0%, rgba(255,255,255,0) 70%);
    pointer-events: none;
}

.hero-icon-wrap {
    width: 64px;
    height: 64px;
    border-radius: 20px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 1.5rem;
    background: rgba(255, 255, 255, 0.14);
    border: 1px solid rgba(255, 255, 255, 0.18);
    box-shadow: 0 12px 30px rgba(11, 15, 40, 0.18);
    flex-shrink: 0;
}

.eyebrow {
    display: inline-block;
    font-size: 0.78rem;
    text-transform: uppercase;
    letter-spacing: 0.12em;
    opacity: 0.72;
    margin-bottom: 0.35rem;
}

.hero-title {
    color: #fff;
    font-size: clamp(1.6rem, 2vw, 2.2rem);
    font-weight: 700;
}

.hero-subtitle {
    color: rgba(255,255,255,0.82);
    max-width: 620px;
}

.summary-card {
    min-height: 128px;
    border-radius: 22px;
    padding: 1rem 1.1rem;
    background: rgba(255, 255, 255, 0.12);
    border: 1px solid rgba(255, 255, 255, 0.14);
    backdrop-filter: blur(8px);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 0.5rem;
}

.summary-label,
.summary-helper {
    color: rgba(255,255,255,0.78);
}

.summary-label {
    font-size: 0.9rem;
}

.summary-helper {
    font-size: 0.82rem;
}

.summary-value {
    color: #fff;
    font-size: clamp(1.25rem, 1.4vw, 1.6rem);
    line-height: 1.1;
}

.objective-header-btn {
    min-height: 46px;
    border-radius: 14px;
    font-weight: 600;
    padding-inline: 1rem;
}

.objectives-list-card {
    border-radius: 28px;
    background: rgba(255,255,255,0.88);
}

.objectives-progress-chip {
    display: inline-flex;
    align-items: center;
    gap: 0.7rem;
    border-radius: 999px;
    padding: 0.5rem 0.85rem;
    background: #f4f7fb;
    color: #34506f;
    font-size: 0.92rem;
}

.objectives-progress-chip strong {
    font-size: 1rem;
}

.overall-progress {
    height: 12px;
    border-radius: 999px;
    background: #edf1f6;
    overflow: hidden;
}

.overall-progress-bar {
    height: 100%;
    border-radius: inherit;
    background: linear-gradient(90deg, #22c55e 0%, #16a34a 100%);
    transition: width 0.3s ease;
}

.empty-state {
    max-width: 560px;
    margin: 0 auto;
}

.empty-state-icon {
    width: 72px;
    height: 72px;
    border-radius: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.7rem;
    background: #f3f6fb;
    color: #2b4d75;
}

.objectives-grid {
    display: grid;
    gap: 1rem;
}

.floating-add-button {
    position: fixed;
    right: 1.5rem;
    bottom: 1.5rem;
    width: 60px;
    height: 60px;
    border: none;
    border-radius: 20px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 1.35rem;
    background: linear-gradient(135deg, #d49039 0%, #c97d24 100%);
    color: #fff;
    box-shadow: 0 18px 30px rgba(201, 125, 36, 0.35);
    z-index: 20;
}

.objetive-date-label{
    margin-bottom: 10px !important;
}

:deep(.objectives-grid > *) {
    width: 100%;
}

:deep(.objectives-grid .card),
:deep(.objectives-grid .goal-card),
:deep(.objectives-grid .objetive-card),
:deep(.objectives-grid .objective-card) {
    border-radius: 22px !important;
    border: 1px solid #eef2f6;
    box-shadow: 0 12px 30px rgba(15, 23, 42, 0.06);
}

:deep(.objectives-grid .btn) {
    border-radius: 12px;
}

:deep(.modal-content) {
    border: none;
    border-radius: 24px;
    overflow: hidden;
    box-shadow: 0 24px 60px rgba(15, 23, 42, 0.18);
}

:deep(.modal-body) {
    padding: 1.4rem;
}

:deep(.form-control),
:deep(.form-select) {
    min-height: 54px;
    border-radius: 14px;
}

:deep(.btn-success),
:deep(.btn-danger),
:deep(.btn-warning),
:deep(.btn-primary) {
    border-radius: 14px;
    min-height: 46px;
    padding-inline: 1rem;
}


.objective-refresh-btn {
    background: rgba(255, 255, 255, 0.08);
    border: 1px solid rgba(143, 177, 219, 0.45);
    color: #d8e6f8;

    box-shadow: 0 10px 22px rgba(7, 23, 45, 0.10);
}

.objective-refresh-btn:hover,
.objective-refresh-btn:focus {
    background: rgba(255, 255, 255, 0.14);
    border-color: rgba(203, 223, 249, 0.8);
    color: #ffffff;
}

.objective-add-btn {
    background: linear-gradient(135deg, #d89239 0%, #c97d24 100%);
    border: 1px solid rgba(255, 214, 163, 0.18);
    color: #fff;
    box-shadow: 0 16px 28px rgba(201, 125, 36, 0.34);
}

.objective-add-btn:hover,
.objective-add-btn:focus {
    background: linear-gradient(135deg, #e09a40 0%, #cf8024 100%);
    color: #fff;
    transform: translateY(-1px);
}

.transaction-modal-content {
    border: none !important;
    border-radius: 28px;
    overflow: hidden;
}

.transaction-modal-deposit {
    box-shadow: 0 24px 60px rgba(15, 23, 42, 0.18);
}

.transaction-modal-withdraw {
    box-shadow: 0 24px 60px rgba(15, 23, 42, 0.18);
}

.transaction-modal-body {
    padding: 1.35rem 1.35rem 1.5rem;
}

.transaction-modal-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 1rem;
}

.transaction-modal-kicker {
    font-size: 0.78rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: #7a8799;
    margin-bottom: 0.35rem;
}

.transaction-modal-title {
    color: #23395b;
    font-size: 1.35rem;
    font-weight: 700;
    line-height: 1.25;
}

.transaction-close-btn {
    width: 40px;
    height: 40px;
    border-radius: 999px;
    border: 1px solid #e7a24f;
    background: #fff8ef;
    color: #d7862a;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
}

.transaction-close-btn:hover {
    background: #fff1df;
    color: #c97616;
}

.transaction-form-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 1rem;
}

.transaction-field label {
    display: block;
    margin-bottom: 0.45rem;
    font-size: 0.92rem;
    font-weight: 600;
    color: #334155;
}

.transaction-input {
    min-height: 54px;
    border-radius: 16px !important;
    border: 1px solid #d6dce5;
    padding-inline: 0.9rem;
    box-shadow: none;
}

.transaction-input:focus {
    border-color: #7aa1d6;
    box-shadow: 0 0 0 4px rgba(122, 161, 214, 0.14);
}

.transaction-modal-actions {
    display: flex;
    justify-content: center;
    margin-top: 1.35rem;
}

.transaction-save-btn {
    min-width: 140px;
    border: none;
    border-radius: 16px !important;
    font-weight: 700;
    padding: 0.9rem 1.4rem;
    color: #fff !important;
}

.transaction-save-btn-deposit {
    background: linear-gradient(135deg, #34c97b 0%, #29b86d 100%);
    box-shadow: 0 14px 28px rgba(52, 201, 123, 0.28);
}

.transaction-save-btn-deposit:hover,
.transaction-save-btn-deposit:focus {
    background: linear-gradient(135deg, #2fc273 0%, #25ad66 100%);
}

.transaction-save-btn-withdraw {
    background: linear-gradient(135deg, #f59e0b 0%, #e58900 100%);
    box-shadow: 0 14px 28px rgba(245, 158, 11, 0.24);
}

.transaction-save-btn-withdraw:hover,
.transaction-save-btn-withdraw:focus {
    background: linear-gradient(135deg, #ed9808 0%, #db8200 100%);
}

@media (max-width: 991.98px) {
    .floating-add-button {
        width: 56px;
        height: 56px;
        right: 1rem;
        bottom: 1rem;
    }

    .objetives-page {
        padding-bottom: 5rem !important;
    }
}


@media (max-width: 767.98px) {
    .transaction-form-grid {
        grid-template-columns: 1fr;
    }

    .transaction-modal-title {
        font-size: 1.15rem;
    }

    .objetives-hero,
    .objectives-list-card {
        border-radius: 22px;
    }

    .summary-card {
        min-height: auto;
    }
}


.objective-create-modal-dialog {
    max-width: 920px;
}

.objective-modal {
    border: none;
    border-radius: 24px;
    overflow: hidden;
    box-shadow: 0 24px 60px rgba(15, 23, 42, 0.18);
    background: #ffffff;
}

.objective-modal-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 1rem;
    padding: 1.25rem 1.25rem 0.85rem;
}

.objective-modal-header h4 {
    margin: 0 0 0.2rem;
    font-size: 1.45rem;
    font-weight: 700;
    color: #213E60;
}

.objective-modal-header span {
    color: #6b7c93;
    font-size: 0.95rem;
    line-height: 1.45;
}

.objective-close {
    width: 40px;
    height: 40px;
    border-radius: 12px;
    border: 1px solid #d8e2ee;
    background: #f8fafc;
    color: #607392;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: all .2s ease;
}

.objective-close:hover {
    background: #eef4fb;
    color: #213E60;
}

.objective-modal-body {
    padding: 0 1.25rem 1rem;
    max-height: 70vh;
    overflow-y: auto;
}

.objective-preview {
    display: flex;
    align-items: center;
    gap: 0.9rem;
    padding: 0.9rem 1rem;
    border: 1px solid #dbe5f0;
    border-radius: 20px;
    background: linear-gradient(180deg, #ffffff 0%, #f6f9fc 100%);
    margin-bottom: 1rem;
}

.preview-icon {
    width: 68px;
    height: 68px;
    border-radius: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.7rem;
    box-shadow: 0 10px 20px rgba(15, 23, 42, 0.12);
}

.objective-preview span {
    color: #6b7c93;
    font-size: 0.92rem;
    font-weight: 600;
}

.objective-form-card {
    background: #ffffff;
    border: 1px solid #dbe5f0;
    border-radius: 20px;
    padding: 1rem;
    margin-bottom: 1rem;
}

.objective-field-label {
    display: block;
    margin-bottom: 0.45rem;
    font-weight: 600;
    color: #344766;
}

.input-modern {
    width: 100%;
    border-radius: 14px;
    padding: 0.82rem 1rem;
    border: 1px solid #d7e0ea;
    min-height: 54px;
    box-shadow: none;
    background: #ffffff;
}

.input-modern:focus {
    border-color: #7ea7d2;
    box-shadow: 0 0 0 4px rgba(126, 167, 210, 0.14);
}

.switch-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
    border: 1px solid #dbe5f0;
    border-radius: 18px;
    padding: 0.9rem 1rem;
    background: #f8fafc;
}

.switch-row strong {
    display: block;
    color: #344766;
    font-size: 0.98rem;
}

.switch-row small {
    display: block;
    color: #6b7c93;
    font-size: 0.84rem;
    margin-top: 0.15rem;
}

.switch {
    position: relative;
    display: inline-flex;
    width: 50px;
    min-width: 50px;
    height: 30px;
}

.switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

.switch span {
    position: absolute;
    inset: 0;
    background: #d7e0ea;
    border-radius: 999px;
    cursor: pointer;
    transition: .2s ease;
}

.switch span::before {
    content: "";
    position: absolute;
    width: 22px;
    height: 22px;
    left: 4px;
    top: 4px;
    border-radius: 50%;
    background: #fff;
    box-shadow: 0 2px 8px rgba(15, 23, 42, 0.12);
    transition: .2s ease;
}

.switch input:checked + span {
    background: #d89239;
}

.switch input:checked + span::before {
    transform: translateX(20px);
}

.objective-section {
    background: #ffffff;
    border: 1px solid #dbe5f0;
    border-radius: 20px;
    padding: 1rem;
    margin-bottom: 1rem;
}

.objective-section-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
    margin-bottom: 0.85rem;
}

.objective-section-head h5 {
    margin: 0;
    color: #344766;
    font-size: 1rem;
    font-weight: 700;
}

.objective-section-head span {
    color: #6b7c93;
    font-size: 0.8rem;
    background: #f3f7fb;
    padding: 0.35rem 0.65rem;
    border-radius: 999px;
}

.objective-icons-wrapper {
    max-height: 280px;
    overflow-y: auto;
    padding-right: 0.2rem;
}

.objective-icon-group + .objective-icon-group {
    margin-top: 1rem;
}

.objective-group-title {
    font-size: 0.82rem;
    font-weight: 700;
    color: #607392;
    margin-bottom: 0.65rem;
}

.objective-icon-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(48px, 1fr));
    gap: 0.6rem;
}

.icon-item {
    height: 46px;
    border-radius: 14px;
    border: 1px solid #d7e0ea;
    background: #f8fafc;
    color: #344766;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: all .2s ease;
}

.icon-item:hover {
    background: #eef4fb;
    border-color: #9fbad8;
    transform: translateY(-1px);
}

.icon-item.active {
    background: #213E60;
    border-color: #213E60;
    color: #ffffff;
    box-shadow: 0 12px 24px rgba(33, 62, 96, 0.18);
}

.color-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(42px, 1fr));
    gap: 0.7rem;
}

.color-item {
    width: 100%;
    aspect-ratio: 1 / 1;
    border-radius: 12px;
    border: 2px solid transparent;
    box-shadow: inset 0 0 0 1px rgba(255,255,255,0.55);
    transition: all .2s ease;
}

.color-item:hover {
    transform: translateY(-1px) scale(1.03);
}

.color-item.active {
    border-color: #213E60;
    box-shadow: 0 0 0 4px rgba(33, 62, 96, 0.12);
}

.objective-footer {
    position: sticky;
    bottom: 0;
    padding: 0.9rem 1.25rem 1.25rem;
    background: linear-gradient(180deg, rgba(255,255,255,0) 0%, #ffffff 22%, #ffffff 100%);
}

.btn-save {
    width: 100%;
    min-height: 50px;
    border: none;
    border-radius: 14px;
    background: linear-gradient(135deg, #d89239 0%, #c97d24 100%);
    color: #ffffff;
    font-weight: 700;
    box-shadow: 0 18px 34px rgba(201, 125, 36, 0.24);
}

.btn-save:hover,
.btn-save:focus {
    color: #ffffff;
    background: linear-gradient(135deg, #e09a40 0%, #cf8024 100%);
    transform: translateY(-1px);
}

.darkmode.objective-modal,
.darkmode .objective-form-card,
.darkmode .objective-section,
.darkmode .objective-preview {
    background: #162233;
    border-color: rgba(255,255,255,0.08);
}

.darkmode .objective-modal-header h4,
.darkmode .objective-field-label,
.darkmode .switch-row strong,
.darkmode .objective-section-head h5,
.darkmode .icon-item {
    color: #f4f7fb;
}

.darkmode .objective-modal-header span,
.darkmode .objective-preview span,
.darkmode .switch-row small,
.darkmode .objective-section-head span,
.darkmode .objective-group-title {
    color: rgba(244,247,251,0.74);
}

.darkmode .input-modern,
.darkmode .switch-row,
.darkmode .icon-item,
.darkmode .objective-close {
    background: #1e2d42;
    border-color: rgba(255,255,255,0.08);
    color: #f4f7fb;
}

.darkmode .objective-section-head span {
    background: rgba(255,255,255,0.06);
}

.darkmode .objective-footer {
    background: linear-gradient(180deg, rgba(22,34,51,0) 0%, #162233 22%, #162233 100%);
}

@media (max-width: 767.98px) {
    .objective-create-modal-dialog {
        margin: 0.75rem;
    }

    .objective-modal-header {
        padding: 1rem 1rem 0.75rem;
    }

    .objective-modal-body {
        padding: 0 1rem 0.9rem;
        max-height: 72vh;
    }

    .objective-preview {
        padding: 0.8rem;
    }

    .preview-icon {
        width: 58px;
        height: 58px;
        font-size: 1.45rem;
    }

    .objective-footer {
        padding: 0.8rem 1rem 1rem;
    }

    .objective-section,
    .objective-form-card {
        padding: 0.9rem;
    }

    .objective-icon-grid {
        grid-template-columns: repeat(auto-fill, minmax(44px, 1fr));
        gap: 0.5rem;
    }

    .color-grid {
        grid-template-columns: repeat(6, 1fr);
        gap: 0.55rem;
    }
}



.objective-delete-modal {
    max-width: 540px;
}

.objective-delete-modal-content {
    border: none;
    border-radius: 24px;
    overflow: hidden;
    box-shadow: 0 24px 60px rgba(15, 23, 42, 0.18);
    background: #ffffff;
}

.objective-delete-modal-body {
    padding: 1.25rem;
}

.objective-delete-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 1rem;
    margin-bottom: 1rem;
}

.objective-delete-kicker {
    font-size: 0.78rem;
    text-transform: uppercase;
    letter-spacing: 0.12em;
    color: #7b8ca7;
    margin-bottom: 0.3rem;
}

.objective-delete-title {
    color: #213E60;
    font-size: 1.35rem;
    font-weight: 700;
}

.objective-delete-close {
    width: 40px;
    height: 40px;
    border-radius: 12px;
    border: 1px solid #d8e2ee;
    background: #f8fafc;
    color: #607392;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: all .2s ease;
}

.objective-delete-close:hover {
    background: #eef4fb;
    color: #213E60;
}

.objective-delete-card {
    display: flex;
    align-items: flex-start;
    gap: 1rem;
    border: 1px solid #f0d7d7;
    background: linear-gradient(180deg, #fff8f8 0%, #fff 100%);
    border-radius: 20px;
    padding: 1rem;
}

.objective-delete-icon {
    width: 56px;
    height: 56px;
    min-width: 56px;
    border-radius: 18px;
    background: #ffe8e8;
    color: #d64545;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 1.35rem;
}

.objective-delete-copy h6 {
    margin: 0 0 0.35rem;
    color: #213E60;
    font-size: 1.05rem;
    font-weight: 700;
}

.objective-delete-copy p {
    color: #6b7c93;
    line-height: 1.5;
    font-size: 0.95rem;
}

.objective-delete-actions {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.85rem;
    margin-top: 1rem;
}

.objective-delete-cancel,
.objective-delete-confirm {
    min-height: 50px;
    border-radius: 14px;
    font-weight: 700;
    border: none;
}

.objective-delete-cancel {
    background: #f8fafc;
    color: #344766;
    border: 1px solid #d7e0ea;
}

.objective-delete-cancel:hover,
.objective-delete-cancel:focus {
    background: #eef4fb;
    color: #213E60;
}

.objective-delete-confirm {
    color: #ffffff;
    background: linear-gradient(135deg, #ef6b6b 0%, #d64545 100%);
    box-shadow: 0 18px 34px rgba(214, 69, 69, 0.20);
}

.objective-delete-confirm:hover,
.objective-delete-confirm:focus {
    color: #ffffff;
    background: linear-gradient(135deg, #f37a7a 0%, #dc5252 100%);
}

.darkmode.objective-delete-modal-content {
    background: #162233;
}

.darkmode .objective-delete-title,
.darkmode .objective-delete-copy h6 {
    color: #f4f7fb;
}

.darkmode .objective-delete-kicker,
.darkmode .objective-delete-copy p {
    color: rgba(244,247,251,0.74);
}

.darkmode .objective-delete-close {
    background: #1e2d42;
    border-color: rgba(255,255,255,0.08);
    color: #f4f7fb;
}

.darkmode .objective-delete-card {
    background: #1e2d42;
    border-color: rgba(239,107,107,0.2);
}

.darkmode .objective-delete-icon {
    background: rgba(239,107,107,0.12);
}

@media (max-width: 767.98px) {
    .objective-delete-actions {
        grid-template-columns: 1fr;
    }
}



.objective-transaction-modal-dialog {
    max-width: 620px;
}

.objective-transaction-kicker {
    font-size: 0.78rem;
    text-transform: uppercase;
    letter-spacing: 0.12em;
    color: #7b8ca7;
    margin-bottom: 0.3rem;
    font-weight: 700;
}

.objective-transaction-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
}

.objective-date-wrap {
    position: relative;
}

.objective-date-input {
    padding-right: 3.2rem !important;
}

.objective-date-wrap .flatpickr-input[readonly],
.objective-date-wrap input[readonly] {
    background: #ffffff;
}

.objective-date-trigger {
    position: absolute;
    right: 0.8rem;
    top: 50%;
    transform: translateY(-50%);
    width: 36px;
    height: 36px;
    border: none;
    border-radius: 10px;
    background: transparent;
    color: #607392;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.objective-date-trigger:hover {
    background: #eef4fb;
    color: #213E60;
}

.objective-transaction-footer {
    display: flex;
    justify-content: center;
}

.objective-transaction-save {
    min-width: 170px;
}

.objective-transaction-save.is-deposit {
    background: linear-gradient(135deg, #2fc56f 0%, #23b562 100%);
    box-shadow: 0 18px 34px rgba(35, 181, 98, 0.22);
}

.objective-transaction-save.is-deposit:hover,
.objective-transaction-save.is-deposit:focus {
    background: linear-gradient(135deg, #35cf77 0%, #25bc66 100%);
}

.objective-transaction-save.is-withdraw {
    background: linear-gradient(135deg, #d89239 0%, #c97d24 100%);
    box-shadow: 0 18px 34px rgba(201, 125, 36, 0.24);
}

.objective-transaction-save.is-withdraw:hover,
.objective-transaction-save.is-withdraw:focus {
    background: linear-gradient(135deg, #e09a40 0%, #cf8024 100%);
}

.darkmode .objective-transaction-kicker {
    color: rgba(244,247,251,0.74);
}

.darkmode .objective-date-wrap .flatpickr-input[readonly],
.darkmode .objective-date-wrap input[readonly],
.darkmode .objective-date-trigger {
    background: #1e2d42;
    color: #f4f7fb;
}

@media (max-width: 767.98px) {
    .objective-transaction-grid {
        grid-template-columns: 1fr;
        gap: 0.85rem;
    }

    .objective-transaction-save {
        width: 100%;
    }
}


@media (max-width: 767.98px) {
    .objective-summary-row {
        margin-top: 0.55rem !important;
        row-gap: 0.55rem !important;
    }

    .summary-card {
        min-height: 108px !important;
        padding: 0.72rem 0.8rem !important;
        border-radius: 14px !important;
    }

    .summary-label {
        font-size: 0.78rem !important;
        line-height: 1.2 !important;
    }

    .summary-value {
        font-size: 0.95rem !important;
        line-height: 1.15 !important;
        word-break: break-word;
    }

    .summary-helper {
        font-size: 0.68rem !important;
        line-height: 1.2 !important;
    }

    .objetives-page{
        margin-bottom: 40px !important;
    }
}

</style>
